import styled, { css } from 'styled-components'
import { carrouselAssets } from './carrouselAssets'
import { assets } from 'common'

const designer3CSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/landing.css */
  .carousel__slide h1 {
    font-size: 1.2rem;
    font-weight: 700;
    letter-spacing: -0.01em;
    padding: 0 0 10px 0;
    text-align: left;
    line-height: 140%;
  }
  .carousel__slide h2 {
    font-size: 2.9rem;
    font-weight: 200;
    letter-spacing: -0.02em;
    text-align: left;
    padding: 0 20px 0 0;
    line-height: 110%;
  }
  &.hero {
    width: 90%;
    max-height: 150px;
    min-height: 150px;
    height: 150px;
    border-radius: 10px;
    margin: 0 0 5px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 140%;
    text-align: center;
    position: relative;
    flex-direction: column;
    z-index: 2;
  }
  @media (max-width: 1600px) {
    .carousel__slide h1 {
      font-size: 1rem;
    }
    .carousel__slide h2 {
      font-size: 2.6rem;
    }
  }
  @media (max-width: 1250px) {
    .carousel__slide {
      padding: 30px 30px;
    }
    &.hero {
      width: 90%;
    }
  }
  @media (max-width: 800px) {
    .carousel__slide h1 {
      font-size: 0.9rem;
    }
    .carousel__slide h2 {
      font-size: 2.2rem;
    }
    &.hero {
      width: 95%;
    }
  }
  @media (max-width: 600px) {
    .carousel__slide {
      flex-direction: column;
      padding: 20px;
      justify-content: center;
      height: calc(100% - 25px);
    }
    .carousel__slide h1 {
      font-size: 0.8rem;
      text-align: center;
      order: 2;
    }
    .carousel__slide h2 {
      font-size: 1.7rem;
      text-align: center;
      padding: 5px 0;
      width: 100%;
      order: 1;
    }
    .carousel__slide .left {
      order: 2;
      align-items: center;
    }
    .carousel__slide .right {
      order: 1;
    }
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/landing_carousel.css */
  .carousel {
    height: 100%;
    width: 100%;
    overflow: hidden;
    text-align: center;
    position: relative;
    padding: 0;
    list-style: none;
  }
  .carousel__controls,
  .carousel__activator {
    display: none;
  }

  .carousel__control {
    height: 30px;
    width: 30px;
    margin-top: -15px;
    top: 50%;
    position: absolute;
    display: block;
    cursor: pointer;
    border-width: 5px 5px 0 0;
    border-style: solid;
    border-color: #fafafa;
    opacity: 0.35;
    outline: 0;
    z-index: 3;
  }
  .carousel__control:hover {
    opacity: 1;
  }
  .carousel__control--backward {
    left: 10px;
    transform: rotate(-135deg);
    display: none;
  }
  .carousel__control--forward {
    right: 10px;
    transform: rotate(45deg);
    display: none;
  }
  .carousel__indicators {
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
  }
  .carousel__indicator {
    height: 10px;
    width: 10px;
    border-radius: 100%;
    display: inline-block;
    z-index: 2;
    cursor: pointer;
    opacity: 0.35;
    margin: 0 5px;
  }
  .carousel__indicator:hover {
    opacity: 0.75;
  }
  .carousel__track {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    padding: 0;
    margin: 0;
    transition: transform 0.5s ease 0s;
  }
  .carousel__track .carousel__slide {
    display: flex;
    top: 0;
    left: 0;
    right: 0;
    opacity: 1;
  }

  .carousel__slide {
    height: calc(100% - 25px);
    border-radius: 10px;
    position: absolute;
    overflow-y: auto;
    opacity: 0;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    padding: 30px 60px;
  }
  .carousel-container {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
  .my-carousel {
    border-radius: 5px;
  }
  .carousel__slide {
    overflow: hidden;
  }
  .carousel__indicator {
    background-color: #fafafa;
  }
  .carousel__slide:nth-of-type(2) h1,
  .carousel__slide:nth-of-type(2) h2 {
    text-shadow: 0 0 10px hsla(0, 0%, 0%, 1);
  }
  .carousel__slide .left {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
  }
  .carousel__slide .right {
    display: flex;
    height: 100%;
    justify-content: flex-end;
  }
  .carousel__slide.stocks_are_back {
    padding: 0;
    justify-content: space-between;
  }
  .carousel__slide.stocks_are_back div.slide-hover {
    display: flex;
    align-items: center;
    position: relative;
    justify-content: space-between;
    height: 100%;
    width: 100%;
    box-shadow: inset 0 0 100px 20px hsla(0, 0%, 0%, 0.1);
    border-radius: 10px;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
  }
  .carousel__slide.stocks_are_back div.slide-hover:hover {
    box-shadow: inset 0 0 0 1px hsl(260, 91%, 64%);
  }
  .carousel__slide.stocks_are_back {
    background-image: url(${carrouselAssets.slide_2_bg});
    background-size: cover;
    background-position: top left;
  }
  .carousel__slide.stocks_are_back h1 {
    font-size: 2.3rem;
    font-weight: 800;
    letter-spacing: -0.03em;
    padding: 0;
    text-align: left;
    line-height: 100%;
    text-shadow: 0;
    text-transform: uppercase;
    height: 100%;
  }
  .carousel__slide.stocks_are_back .left:before {
    mask: url(${carrouselAssets.leveraged_synth_stocks_icon}) center left / 70px auto no-repeat;
    background: hsla(260, 91%, 64%, 1);
    width: 70px;
    height: 100%;
    position: absolute;
    content: '';
    left: 30px;
    top: 50%;
    transform: translateY(-50%);
  }
  .carousel__slide.stocks_are_back h2 {
    font-size: 1rem;
    font-weight: 300;
    line-height: 130%;
  }
  .carousel__slide.stocks_are_back h2 strong {
    font-weight: 800;
  }
  .carousel__track .carousel__slide.stocks_are_back .left {
    padding: 30px 0 30px 120px;
    position: relative;
  }
  .carousel__track .carousel__slide.stocks_are_back .right {
    position: relative;
    justify-content: flex-start;
    padding: 0 30px 0 15px;
  }
  .carousel__track .carousel__slide.stocks_are_back .right .stocks_icons {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }
  .carousel__track .carousel__slide.stocks_are_back .right .stocks_icons .asset_icon {
    background-size: 65px auto;
    background-position: center center;
    background-repeat: no-repeat;
    width: 65px;
    height: 65px;
    margin: 0 10px 0 0;
  }
  .carousel__track .carousel__slide.stocks_are_back .right .stocks_icons .asset_icon:last-child {
    margin: 0;
  }
  .carousel__track .carousel__slide.stocks_are_back .right .stocks_icons .asset_icon.tsla {
    background-image: url(${assets.tsla_icon});
  }
  .carousel__track .carousel__slide.stocks_are_back .right .stocks_icons .asset_icon.spy {
    background-image: url(${assets.spy_icon});
  }
  .carousel__track .carousel__slide.stocks_are_back .right .stocks_icons .asset_icon.amzn {
    background-image: url(${assets.amzn_icon});
  }
  .carousel__track .carousel__slide.stocks_are_back .right .stocks_icons .asset_icon.googl {
    background-image: url(${assets.googl_icon});
  }
  .carousel__track .carousel__slide.stocks_are_back .right .stocks_icons .asset_icon.aapl {
    background-image: url(${assets.aapl_icon});
    border: 1px solid hsla(0, 0%, 100%, 0.1);
    border-radius: 50%;
  }
  .carousel__track .carousel__slide.stocks_are_back .right .stocks_icons .asset_icon.nvda {
    background-image: url(${assets.nvda_icon});
    border: 1px solid hsla(0, 0%, 100%, 0.1);
    border-radius: 50%;
  }
  .carousel__slide.yolocoaster {
    padding: 0;
    justify-content: flex-start;
  }
  .carousel__slide.yolocoaster div.slide-hover {
    display: flex;
    align-items: center;
    position: relative;
    justify-content: flex-start;
    height: 100%;
    width: 100%;
    box-shadow: inset 0 0 100px 20px hsla(0, 0%, 0%, 0.1);
    border-radius: 10px;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
  }
  .carousel__slide.yolocoaster div.slide-hover:hover {
    box-shadow: inset 0 0 0 1px hsl(221, 73%, 47%);
  }
  .carousel__slide.yolocoaster {
    background-image: url(${carrouselAssets.yolocoaster_banner_bg});
    background-size: cover;
    background-position: top left;
  }
  .carousel__slide.yolocoaster h1 {
    font-size: 3.2rem;
    font-weight: 200;
    letter-spacing: -0.045em;
    padding: 0 80px 0 0;
    text-align: left;
    line-height: 130%;
    text-shadow: 0;
    background: url(${carrouselAssets.yolocoaster_logo_banner}) top left / 300px auto no-repeat;
    width: 300px;
    height: 70px;
  }
  .carousel__track .carousel__slide.yolocoaster .left {
    padding: 30px 5% 30px 40px;
  }
  .carousel__track .carousel__slide.yolocoaster .right {
    position: relative;
    justify-content: flex-start;
    width: calc(100% - 200px);
  }
  .carousel__track .carousel__slide.yolocoaster .right .checklist {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }
  .carousel__track .carousel__slide.yolocoaster .right .checklist .bullet_wrap {
    margin: 0 5% 0 0;
  }
  .carousel__track .carousel__slide.yolocoaster .right .checklist .bullet_wrap:last-child {
    margin: 0;
  }
  .carousel__track .carousel__slide.yolocoaster .right .checklist .bullet {
    font-size: 1rem;
    padding: 10px 15px 10px 30px;
    position: relative;
    text-align: left;
    white-space: nowrap;
  }
  .carousel__track .carousel__slide.yolocoaster .right .checklist .bullet:before {
    mask: url(${carrouselAssets.check_icon_2}) center center / 22px auto no-repeat;
    background: hsl(221, 73%, 47%);
    width: 22px;
    height: 22px;
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .carousel__track .carousel__slide.yolocoaster .right .pepecoaster {
    background: url(${carrouselAssets.yolocoaster_pepecoaster}) center center / 272px 278px no-repeat;
    right: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    width: 272px;
    height: 278px;
    position: absolute;
    z-index: -1;
  }
  .carousel__slide.yolobot {
    padding: 0;
    justify-content: space-between;
  }

  .carousel__slide.yolobot a {
    text-decoration: none;
    display: flex;
    align-items: center;
    position: relative;
    justify-content: space-between;
    height: 100%;
    width: 100%;
    box-shadow: inset 0 0 100px 20px hsla(0, 0%, 0%, 0.1);
    border-radius: 10px;
  }
  .carousel__slide.yolobot a:hover {
    box-shadow: inset 0 0 0 1px hsl(68, 100%, 50%);
  }
  .carousel__slide.yolobot {
    background-image: url('http://yolo.tino.me/app_v3/resources/images/yolobot/yolobot_banner_bg.jpg');
    background-position: center right;
  }
  .carousel__slide.yolobot h1 {
    font-size: 2.3rem;
    font-weight: 800;
    letter-spacing: -0.03em;
    padding: 0;
    text-align: left;
    line-height: 100%;
    text-shadow: 0;
    text-transform: uppercase;
    height: 100%;
    background: url('http://yolo.tino.me/app_v3/resources/images/yolobot/yolobot_logo_2.svg') center center / 200px auto
      no-repeat;
    width: 200px;
    min-width: 200px;
    height: 53px;
    margin-top: 5px;
  }
  .carousel__slide.yolobot h2 {
    font-size: 1rem;
    font-weight: 500;
    line-height: 130%;
    padding: 0 140px 0 40px;
  }
  .carousel__slide.yolobot h2 strong {
    font-weight: 300;
    font-size: 1.6rem;
    display: block;
    color: #deff00;
    padding: 0 0 5px 0;
  }
  .carousel__track .carousel__slide.yolobot .left {
    padding: 30px 0 30px 70px;
    position: relative;
    flex-direction: row;
    align-items: center;
  }
  @media (max-width: 1300px) {
    .carousel__slide.stocks_are_back h1 {
      font-size: 2rem;
      letter-spacing: -0.02em;
      white-space: nowrap;
    }
    .carousel__slide.stocks_are_back h2 {
      font-size: 0.9rem;
    }
    .carousel__track .carousel__slide.stocks_are_back .left {
      padding-left: 100px;
    }
    .carousel__slide.stocks_are_back .left:before {
      -webkit-mask-size: 50px auto;
      width: 50px;
    }
    .carousel__track .carousel__slide.stocks_are_back .right .stocks_icons .asset_icon {
      background-size: 50px auto;
      width: 50px;
      height: 50px;
      margin: 0 5px 0 0;
    }
    .carousel__track .carousel__slide.yolocoaster .left {
      padding: 30px 3% 30px 20px;
    }
    .carousel__track .carousel__slide.yolocoaster .right .checklist .bullet_wrap {
      margin: 0 3% 0 0;
    }
    .carousel__slide.yolocoaster h1 {
      background-size: 230px auto;
      width: 230px;
      height: 52px;
    }
    .carousel__track .carousel__slide.yolocoaster .right .checklist .bullet {
      font-size: 0.9rem;
      padding: 6px 5px 6px 20px;
    }
    .carousel__track .carousel__slide.yolocoaster .right .checklist .bullet:before {
      -webkit-mask-size: 15px auto;
      width: 15px;
      height: 15px;
    }
    .carousel__track .carousel__slide.yolocoaster .right .pepecoaster {
      background-size: 200px 205px;
      background-position: 12px top;
      width: 200px;
      height: 205px;
    }
  }
  @media (max-width: 1000px) {
    .carousel__slide.yolobot {
      background-position: calc(100% + 50px) center;
    }
    .carousel__track .carousel__slide.yolobot .left {
      padding: 30px 0 30px 30px;
    }
    .carousel__slide.yolobot h2 {
      padding-right: 70px;
      font-size: 0.85rem;
    }
    .carousel__slide.yolobot h2 strong {
      font-size: 1.2rem;
    }
    .carousel__slide.stocks_are_back h1 {
      font-size: 1.8rem;
      letter-spacing: -0.01em;
    }
    .carousel__slide.stocks_are_back h2 {
      font-size: 0.85rem;
    }
    .carousel__track .carousel__slide.stocks_are_back .right .stocks_icons .asset_icon {
      background-size: 40px auto;
      width: 40px;
      height: 40px;
    }
    .carousel__track .carousel__slide.yolocoaster .right .checklist .bullet_wrap {
      margin: 0;
    }
    .carousel__track .carousel__slide.yolocoaster .right .checklist .bullet {
      font-size: 0.8rem;
      padding: 5px 0 5px 20px;
    }
    .carousel__track .carousel__slide.yolocoaster .right .pepecoaster {
      background-size: 180px 184px;
      background-position: 12px top;
      width: 180px;
      height: 184px;
    }
  }
`
const slideLogicCSS = css`
  /* SLIDE 1 */
  .carousel__activator:nth-of-type(1):checked ~ .carousel__track {
    transform: translateX(0%);
  }
  .carousel__activator:nth-of-type(1):checked ~ .carousel__controls:nth-of-type(1) {
    display: block;
    opacity: 1;
  }
  .carousel__activator:nth-of-type(1):checked ~ .carousel__indicators .carousel__indicator:nth-of-type(1) {
    opacity: 1;
  }
  .carousel__track .carousel__slide:nth-of-type(1) {
    transform: translateX(0%);
  }

  /* SLIDE 2 */
  .carousel__activator:nth-of-type(2):checked ~ .carousel__track {
    transform: translateX(-100%);
  }
  .carousel__activator:nth-of-type(2):checked ~ .carousel__controls:nth-of-type(2) {
    display: block;
    opacity: 1;
  }
  .carousel__activator:nth-of-type(2):checked ~ .carousel__indicators .carousel__indicator:nth-of-type(2) {
    opacity: 1;
  }
  .carousel__track .carousel__slide:nth-of-type(2) {
    transform: translateX(100%);
  }

  /* SLIDE 3 */
  .carousel__activator:nth-of-type(3):checked ~ .carousel__track {
    transform: translateX(-200%);
  }
  .carousel__activator:nth-of-type(3):checked ~ .carousel__indicators .carousel__indicator:nth-of-type(3) {
    opacity: 1;
  }
  .carousel__track .carousel__slide:nth-of-type(3) {
    transform: translateX(200%);
  }

  /* SLIDE 4 */
  .carousel__activator:nth-of-type(4):checked ~ .carousel__track {
    transform: translateX(-300%);
  }
  .carousel__activator:nth-of-type(4):checked ~ .carousel__indicators .carousel__indicator:nth-of-type(4) {
    opacity: 1;
  }
  .carousel__track .carousel__slide:nth-of-type(4) {
    transform: translateX(300%);
  }
`

const tokenBannerCSS = css`
  /* YOLO TOKEN */

  .carousel__slide.yolo_token {
    padding: 0;
    justify-content: space-between;
  }
  .carousel__slide.yolo_token a {
    display: flex;
    align-items: center;
    position: relative;
    justify-content: space-between;
    height: 100%;
    width: 100%;
    box-shadow: inset 0 0 100px 20px hsla(0, 0%, 0%, 0.1);
    border-radius: 10px;
  }
  .carousel__slide.yolo_token a:hover {
    box-shadow: inset 0 0 0 1px #005cff;
  }
  .carousel__slide.yolo_token,
  .carousel—thumb .carousel__indicators .carousel__indicator:nth-of-type(1) {
    background-image: url(${carrouselAssets.yolo_token_banner_bg});
    background-size: cover;
    background-position: top center;
    width: 100%;
  }
  .carousel__slide.yolo_token h1 {
    font-size: 2.3rem;
    font-weight: 800;
    letter-spacing: -0.03em;
    padding: 0;
    text-align: left;
    line-height: 100%;
    text-shadow: 0;
    text-transform: uppercase;
    height: 100%;
    background: url(${carrouselAssets.yolo_token_logo_hor}) center center / 300px auto no-repeat;
    width: 300px;
    min-width: 300px;
    height: 72px;
  }
  .carousel__slide.yolo_token h2 {
    font-size: 1.2rem;
    font-weight: 600;
    /* line-height: 130%; */
    padding: 0 0 0 40px;
    display: flex;
    flex-direction: column;
    text-shadow: 1px 1px 2px black;
    flex-wrap: wrap;
  }
  .carousel__slide.yolo_token h2 .yt_wrapper {
    display: inline;
    line-height: 130%;
  }
  .carousel__slide.yolo_token h2 strong {
    font-weight: 400;
    font-size: 1.7rem;
    text-transform: uppercase;
    display: block;
    color: #277fff;
    padding: 2px 0 3px 0;
    letter-spacing: -0.01em;
  }
  .carousel__slide.yolo_token h2 .fake_link {
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.4);
  }
  .carousel__slide.yolo_token:hover h2 .fake_link {
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.9);
  }
  .carousel__track .carousel__slide.yolo_token .left {
    padding: 30px 0 30px 70px;
    position: relative;
    flex-direction: row;
    align-items: center;
  }
  .carousel__track .carousel__slide.yolo_token .right {
    position: relative;
    justify-content: flex-start;
    padding: 0 30px 0 15px;
  }
`
const friendTechCSS = css`
/* FRIEND.TECH */

.carousel__slide.friendtech {
    padding: 0;    
    justify-content: space-between;
    }

.carousel__slide.friendtech a {
    display: flex;
    align-items: center;
    position: relative;
    justify-content: space-between;
    height: 100%;
    width: 100%;
    box-shadow: inset 0 0 100px 20px hsla(0,0%,0%,.1);
    border-radius: 10px;
      transition: all 0.3s ease-in-out;
    cursor: pointer;
    }
.carousel__slide.friendtech a:hover {
    box-shadow: inset 0 0 0 1px #00BEFF;
    }        
.carousel__slide.friendtech,
.carousel--thumb .carousel__indicators .carousel__indicator:nth-of-type(1) {
    background-image: url(${carrouselAssets.friend_tech_banner_bg});
    background-size: 100% 100%;
    background-position: left center;
    width: 100%;
    background-color: #0E171A;
    }
.carousel__slide.friendtech {
    height: 125px;
    }    
.carousel__slide.friendtech h1 {
    font-size: 2.3rem;
    font-weight: 800;
    letter-spacing: -.03em;
    padding: 0;
    text-align: left;
    line-height: 100%;
    text-shadow: 0; 
    text-transform: uppercase;
    height: 100%;
    background: url(${carrouselAssets.friend_tech_logo});
    background-size: cover;
      background-position: center;
    width: 350px;
    min-width: 350px;
    }
.carousel__slide.friendtech h2 {        
    font-size: 1.2rem;
    font-weight: 600;
    padding: 0 15px 0 40px;
    display: flex;
    flex-direction: column;
    text-shadow: 1px 1px 2px black;
    flex-wrap: wrap;
    }    
.carousel__slide.friendtech h2 .yt_wrapper {
    display: inline;
    line-height: 130%;
    }    
.carousel__slide.friendtech h2 strong {
    font-weight: 400;
    font-size: 1.7rem;
    text-transform: uppercase;
    display: block;
    color: #00BEFF;
    padding: 2px 0 3px 0;
    letter-spacing: -.01em;
    }        
.carousel__track .carousel__slide.friendtech .left {
    padding: 0;
    position: relative;
    flex-direction: row;
    align-items: center;
    height: 100%;
    }
.carousel__track .carousel__slide.friendtech .right {
    position: absolute;
    right: 0;
    z-index: -1;
    justify-content: flex-start;
    padding: 0 0 0 15px;
    }

/* FRIEND.TECH RESPONSIVE */

@media (max-width: 800px) {
    .carousel__slide.friendtech h1 {
        background-size: 250px auto;
        width: 250px;
        min-width: 250px;
        }    
    .carousel__slide.friendtech h2 {        
        font-size: 1.0rem;
        padding: 0 15px 0 40px;
        }            
    .carousel__slide.friendtech h2 strong {
        font-size: 1.4rem;
        }        
    }
`

const developerCSS = css``

export const CarrouselCSS = styled.div`
  ${designer3CSS}
  ${slideLogicCSS}
  ${tokenBannerCSS}
  ${friendTechCSS}
  ${developerCSS}
`
